export { UserAttendances as default } from "./user-attendances";
